import axios from "axios";

export default {
    getAdStudy() {
        return axios.get("/course/Firstpage/getAdStudy");
    },
    isMember() {
        return axios.get("/course/Usercenter/isMember");
    },
    getCommentNotRead() {
        return axios.get("/course/Usercenter/getCommentNotRead");
    }
}